import { Component, ErrorInfo, ReactNode } from "react";

import { logError } from "~utils/newrelicBrowser";

interface ErrorBoundaryProps {
    fallback?: ReactNode;
    children: ReactNode;
}

class ErrorBoundary extends Component<ErrorBoundaryProps> {
    state = {
        hasError: false,
    };

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error: Error, info: ErrorInfo) {
        const url = window?.location?.href || "";
        const msg = `url: ${url} \n stacktrace: ${info.componentStack}`;

        logError(error, { msg });
    }

    render() {
        if (this.state.hasError) {
            return this.props.fallback || null;
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
